import deepmerge from 'deepmerge';
import {v4 as uuidv4} from 'uuid';

import arrayUtils from './arrayUtils';

type TGuid = () => string;
type TTimeout = (ms: number) => Promise<void>;
type TscrollTop = (yCoord?: number) => void;
type TRunFunction = (func: ((...args: any[]) => void) | null | undefined, arg?: any | any[]) => void;

const guid: TGuid = () => uuidv4();

const timeout: TTimeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const mergeDeep = deepmerge;

const scrollTop: TscrollTop = (yCoord = 0) => window.scrollTo({top: yCoord});

const runFunction: TRunFunction = (func, arg) => {
    const args = arrayUtils.toArray(arg);

    if (typeof func === 'function') {
        return args ? func(...args) : func();
    }
};

const deepClone = (data: any) => JSON.parse(JSON.stringify(data));

const debounce = (func: (...args: any[]) => any, delay: number) => {
    let timerId: ReturnType<typeof setTimeout>;

    return (...args: any) => {
        clearTimeout(timerId);

        timerId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

export default {
    guid,
    mergeDeep,
    scrollTop,
    runFunction,
    timeout,
    deepClone,
    debounce,
};
